import { render, staticRenderFns } from "./TemplatesWhatsApp.vue?vue&type=template&id=69e90fd6&scoped=true"
import script from "./TemplatesWhatsApp.vue?vue&type=script&lang=js"
export * from "./TemplatesWhatsApp.vue?vue&type=script&lang=js"
import style0 from "./TemplatesWhatsApp.vue?vue&type=style&index=0&id=69e90fd6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69e90fd6",
  null
  
)

export default component.exports